import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import './Home.css';

function App() {
  return (
    <Routes>
      <Route path="/binary-analyzer-tool" element={<Home />} />
    </Routes>
  );
}

export default App;
